import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { IntegrationKristeligDagbladData } from './Data';

export interface IntegrationKristeligDagbladState extends BaseIntegrationState {
  timeLimit: {
    enabled: boolean;
    seconds?: number;
  };
  extendedResult: {
    enabled: boolean;
    theme?: string;
  };
}

export class IntegrationKristeligDagbladModel extends BaseIntegration<
  IntegrationKristeligDagbladData,
  IntegrationKristeligDagbladState
> {
  parse(data: IntegrationKristeligDagbladData) {
    super.parse(data);
    this.state.timeLimit = this.state.timeLimit || {};
    this.state.extendedResult = this.state.extendedResult || {};

    this.state.timeLimit.enabled = !!data.settings?.timelimit;
    this.state.timeLimit.seconds = data.settings?.timelimit_time;
    this.state.extendedResult.enabled = !!data.settings?.extended_result;
    this.state.extendedResult.theme = data.settings?.extended_result_theme;
  }

  hasVueComponent() {
    return false;
  }

  authorSignature(): string {
    return 'Ani Mikova';
  }
}
